export enum TravelCompanyType {
  AER = 'AER',
  KM = 'KM',
  GENERAL = 'GENERAL'
}
